export default __webpack_public_path__ + "static/card-android-78ce2eeaf14625648e1bba6e429b18c5.png";